import React, { useState, useEffect } from "react";
import { SideModal, Tabs, TextLink } from "components";
import { subscriptionModalTabRoutes } from "../tab-routes";
import { useSelector } from "react-redux";
import { useParams, useLocation, useHistory } from "react-router-dom";

const SubscriptionSideModal = () => {
  // Routers
  const { id } = useParams();
  const { pathname } = useLocation();
  const { push } = useHistory();

  // Redux

  const { transaction, manualRouting, subscriptionRouting, subsDetail } =
    useSelector(state => ({
      transaction: state.subsDetail?.transaction?.[0],
      subsDetail: state.subsDetail,
      manualRouting: state.manualRouting,
      subscriptionRouting: state.subscriptionRouting
    }));

  const [titles, setTitles] = useState();

  useEffect(() => {
    const titleArr = [
      { key: "Order", value: subsDetail?.cartID },
      {
        key: "Transaction",
        value: (
          <TextLink
            text={transaction?.transactionID}
            onClick={() =>
              window.open(
                `https://dashboard.razorpay.com/app/payments/${transaction?.transactionID}`,
                "_blank"
              )
            }
          />
        )
      },
      pathname?.split("/")?.at(-1) === "manual-routing" &&
        manualRouting && {
          key: "Category",
          value: manualRouting?.[0]?.category_id
        },
      pathname?.split("/")?.at(-1) === "manual-routing" &&
        manualRouting && {
          key: "Sub Category",
          value: manualRouting?.[0]?.subcategory_id
        },
      pathname?.split("/")?.at(-1) === "routing" &&
        subscriptionRouting && {
          key: "User",
          value: subscriptionRouting?.[0]?.user_id
        }
    ];
    setTitles(titleArr);
  }, [transaction, manualRouting, pathname, subscriptionRouting]);

  return (
    <SideModal
      title="Subscription"
      titles={titles?.length ? [...titles] : []}
      onClose={() =>
        push(`/customers/customers/${id}/customer-modal/subscriptions`)
      }>
      <Tabs routes={subscriptionModalTabRoutes} />
    </SideModal>
  );
};

export default SubscriptionSideModal;
